export const GOOGLE_CLIENT_ID = "365216838019-63k0345uebd4sg07eo3d5vmdpb2j1nu0.apps.googleusercontent.com";
